import * as React from "react";

import { TicketList } from "../Tickets/List";
import {useNavigate, NavigateFunction, useLocation, Location, useSearchParams} from "react-router-dom";
import {useParams} from "react-router";
import PageTitle from "Components/Common/PageTitle";

type LandingPageParams = {
    actionplanId: string
    showQuickActionPlan: string
}

export function LandingPage() {
    const navigate = useNavigate();
    const location = useLocation();
    const [searchParams] = useSearchParams();
    const params = useParams<LandingPageParams>();
    const actionplanId = params.actionplanId;

    return (
        <Landing
            actionplanId={actionplanId}
            navigate={navigate}
            overdue={searchParams.get("overdue") === "true"}
            showQuickActionPlan={searchParams.get("showQuickActionPlan") === "true"}
            location={location}/>
    );
}

interface LandingProps {
    actionplanId?: string
    location: Location
    navigate: NavigateFunction
    showQuickActionPlan?: boolean
    overdue?: boolean
}

interface LandingState {
    expandActionplanId: string | undefined
}

export class Landing extends React.Component<LandingProps, LandingState> {
    constructor(props) {
        super(props);
        this.state = {
            expandActionplanId: this.props.actionplanId,
        };
    }

    componentDidMount () {
    }

    static getDerivedStateFromProps(nextProps, state){
        if(nextProps.actionplanId !== state.expandActionplanId){
            return {expandActionplanId: nextProps.actionplanId};
        }
        return null;
    }

    render () {
        return(
            <>
                <PageTitle pageTitle="Actionplans" />
                <TicketList
                    navigate={this.props.navigate}
                    instaOpenId={this.state.expandActionplanId}
                    overdue={this.props.overdue}
                    showQuickActionPlan={this.props.showQuickActionPlan}
                    location={this.props.location}/>
            </>
        );
    }

}
